var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-title"},[_c('router-link',{attrs:{"to":_vm.link,"tag":"div"}},[_vm._t("icon",function(){return [(_vm.icon)?_c('font-awesome-icon',{staticClass:"config-icon",attrs:{"icon":_vm.icon}}):_vm._e()]}),_c('span',[_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }